

















































































































/* eslint-disable @typescript-eslint/no-unused-vars */
import { Vue, Component, Prop }                             from 'vue-property-decorator'
import { mapGetters }                                       from 'vuex'
import { FontAwesomeIcon }                                  from '@fortawesome/vue-fontawesome'

import { Ability }                                          from '@/types/Ability'
import { formatDate, formatNumber, exportDivElementAsImage, getLibellePoste }    from '@/utils/helpers'

import ECharts                                              from 'vue-echarts'
import { use }                                              from 'echarts/core'

// import ECharts modules manually to reduce bundle size
import {
    CanvasRenderer
} from 'echarts/renderers'
import {
    BarChart, BoxplotChart, ScatterChart
} from 'echarts/charts'
import {
    DatasetComponent,
    GridComponent,
    MarkLineComponent,
    TitleComponent,
    TooltipComponent,
    TransformComponent
} from 'echarts/components'
import { incrementArrayChartOutliersDetail, getCurrentNbOfCurrentOutliers } from '@/store/modules/EchartsToolsManage'
import { TypePassation } from '@/types/Epreuve'

// import html2canvas from 'html2canvas'

// import { installUniversalTransition } from 'echarts/types/dist/shared'

use([
    CanvasRenderer,
    BarChart,
    TooltipComponent,
    GridComponent,
    DatasetComponent,
    TitleComponent,
    TooltipComponent,
    GridComponent,
    TransformComponent,
    BoxplotChart,
    ScatterChart,
    CanvasRenderer, MarkLineComponent
])

/**
 * Composant contenant l'ensemble des epreuveCorrectionResultats
*/
@Component({
    computed: {
        ...mapGetters('auth', ['authUser', 'can', 'cannot', 'isA', 'isNotA']),
        ...mapGetters('epreuveCorrectionResultat', ['epreuveCorrectionResultatSelect', 'epreuveCorrectionCorrecteurs', 'dicoNotesByUserId', 'notes', 'loading', 'totalRows', 'lastPage', 'totalPage'])
    },
    components: {
        'font-awesome-icon': FontAwesomeIcon,
        ECharts
    }
})

export default class Statistiques extends Vue {
    @Prop() epreuvecorrectionId: any
    @Prop() visible?: boolean

    TypePassation = TypePassation
    exportDivElementAsImage = exportDivElementAsImage
    getLibellePoste = getLibellePoste

    showModalEditionCandidat?:          boolean = false
    showModalEditionCommentCandidat?:   boolean = false
    formatDate = formatDate
    formatNumber = formatNumber
    sessionActive: any = null
    tableLoading = false
    loadingData = false

    option: any = null
    option2: any = null

    selected_correcteur_id = 0
    selected_filiere_id = 0
    totalZero = 0
    totalVingt = 0

    epreuve_id = 0

    ecart_type_notes_brutes = '0'
    ecart_type_notes_finales = '0'

    mediane_notes_brutes = 0
    mediane_notes_finales = 0

    moyenne_notes_brutes = '0'
    moyenne_notes_finales = '0'

    premier_quartile_notes_finales = 0
    premier_quartile_notes_brutes = 0

    troisieme_quartile_notes_finales = 0
    troisieme_quartile_notes_brutes = 0

    nb_note_max_brutes = 0
    nb_note_max_finales = 0

    nb_note_min_brutes = 0
    nb_note_min_finales = 0

    nb_class = 20
    note_max = 20

    arrayChartOutliersTotal: any = []

    Ability = Ability

    // Ensemble des colonnes du tableau de epreuveCorrectionResultats
    stickyHeader = true


    majNbOutliers() {
        this.arrayChartOutliersTotal =  this.$store.state.echartsToolsManage.arrayChartOutliersTotal
    }

    buildChartOptions () {
        if (this.selected_correcteur_id !== 0) {
            this.selected_filiere_id = 0
        }
        const data = this.$store.getters['epreuveCorrectionResultat/dicoNotesByUserId'](this.selected_correcteur_id, this.nb_class, this.note_max, this.epreuve_id)

        // Réinit forcé des tableaux des nbr d'outliers
        this.$store.state.echartsToolsManage.arrayChartOutliersTotal = []
        this.$store.state.echartsToolsManage.arrayChartOutliersDetail = []

        this.totalZero =  data &&  data.finale &&  data.finale.dico &&  data.finale.dico[0] &&  data.finale.dico[0].total ? data.finale.dico[0].total : '0'
        this.totalVingt =  data &&  data.finale &&  data.finale.dico &&  data.finale.dico[20] &&  data.finale.dico[20].total ? data.finale.dico[20].total : '0'

        this.ecart_type_notes_brutes = data && data.ecart_type_notes_brutes ? formatNumber(data.ecart_type_notes_brutes) : '0'
        this.ecart_type_notes_finales = data && data.ecart_type_notes_finales ? formatNumber(data.ecart_type_notes_finales) : '0'

        this.mediane_notes_brutes = data && data.mediane_notes_brutes ? data.mediane_notes_brutes : '0'
        this.mediane_notes_finales = data && data.mediane_notes_finales ? data.mediane_notes_finales : '0'

        this.moyenne_notes_brutes = data &&  data.moyenne_notes_brutes ? formatNumber(data.moyenne_notes_brutes) : '0'
        this.moyenne_notes_finales = data && data.moyenne_notes_finales ? formatNumber(data.moyenne_notes_finales) : '0'

        this.premier_quartile_notes_brutes =  data && data.premier_quartile_notes_brutes ? data.premier_quartile_notes_brutes : '0'
        this.premier_quartile_notes_finales = data && data.premier_quartile_notes_finales ? data.premier_quartile_notes_finales : '0'

        this.troisieme_quartile_notes_brutes =  data && data.troisieme_quartile_notes_brutes ? data.troisieme_quartile_notes_brutes : '0'
        this.troisieme_quartile_notes_finales = data && data.troisieme_quartile_notes_finales ? data.troisieme_quartile_notes_finales : '0'

        this.nb_note_max_brutes =  data && data.nb_note_max_brutes ? data.nb_note_max_brutes : '0'
        this.nb_note_max_finales =  data && data.nb_note_max_finales ? data.nb_note_max_finales : '0'

        this.nb_note_min_brutes =  data && data.nb_note_min_brutes ? data.nb_note_min_brutes : '0'
        this.nb_note_min_finales =  data && data.nb_note_min_finales ? data.nb_note_min_finales : '0'

        const xaxisData = []
        const rapnb_saallaNoteMax =  this.note_max / this.nb_class

        const moyForChart = parseFloat(this.moyenne_notes_finales)
        const ecartTypNeg =  parseFloat(this.moyenne_notes_finales) - parseFloat(this.ecart_type_notes_finales)
        const ecartTyPos =  parseFloat(this.moyenne_notes_finales) + parseFloat(this.ecart_type_notes_finales)

        for (let i = 0; i < this.note_max; i = i + rapnb_saallaNoteMax) {
            xaxisData.push('[' + i + '-' + (i + rapnb_saallaNoteMax) + ((i + rapnb_saallaNoteMax) === this.note_max ? ']' : '['))
        }

        this.option = null
        this.option = {
            autoresize: true,
            cursor: 'default',
            animationDuration: 500,
            grid: {
                left: 40,
                top: 20,
                right: 40,
                bottom: 5
            },
            tooltip: {
                trigger: 'item',
                formatter: '{b} : {c}'
            },
            xAxis: [{
                type: 'category',
                data: xaxisData
            },
            {
                type: 'value',
                min: 0,
                max: this.note_max,
                show: false
            }
            ],
            yAxis: {
                type: 'value'
            },
            series: [
                {
                    data: data.finale.table,
                    type: 'bar',
                    showBackground: false,
                    silent: false,
                    backgroundStyle: {
                        color: 'rgba(180, 180, 180, 0.2)'
                    }
                },
                {
                    xAxisIndex: 1,
                    data : [],
                    type: 'bar',
                    markLine : {
                        symbol:['none', 'none'],
                        silent: false, // ignore mouse events
                        data : [
                            // Horizontal Axis (requires valueIndex = 0)
                            {
                                type : 'average',
                                name: 'Moyenne',
                                valueIndex: 0,
                                xAxis: moyForChart,
                                itemStyle:{ normal:{ color:'red' } },

                                label: {
                                    color: 'red',
                                    formatter: () => { return ''  } // 'Moyenne = ' + moyForChart

                                },

                                lineStyle: {
                                    type: 'solid'
                                }
                            },
                            {
                                type : 'average',
                                name: 'Écart type (' + this.ecart_type_notes_finales + ') ',
                                valueIndex: 0,
                                xAxis: ecartTypNeg,
                                itemStyle:{ normal:{ color:'grey' } },

                                label: {
                                    color: 'grey',
                                    formatter: () => { return '' }

                                },

                                lineStyle: {
                                    type: 'dashed'
                                }
                            },
                            {
                                type : 'average',
                                name: 'Écart type (' + this.ecart_type_notes_finales + ') ',
                                valueIndex: 0,
                                xAxis: ecartTyPos,
                                itemStyle:{ normal:{ color:'grey' } },
                                label: {
                                    color: 'grey',
                                    formatter: () => { return '' }

                                },
                                lineStyle: {
                                    type: 'dashed'
                                }
                            }
                        ]
                    }
                }
            ]
        }

        this.option2 = null
        this.option2 = {
            animationDuration: 500,
            autoresize: true,
            cursor: 'default',
            grid: {
                left: 40,
                top: 0,
                right: 40,
                bottom: 25
            },
            // dataset: data.finale.liste,
            dataset: [
                { source: [data.finale.liste] },
                {
                    transform: {
                        type: 'boxplot'
                    }
                },
                { fromDatasetIndex: 1, fromTransformResult: 1 }
            ],
            tooltip: {
                trigger: 'item',
                axisPointer: {
                    type: 'shadow'
                },
                formatter: (params: any) => {
                    // console.log('params :', params)
                    if (params.data && params.data.length > 4) {
                        return [
                            'Supérieur: ' + Math.round(params.data[5] * 100) / 100,
                            '3eme Quartile: ' + Math.round(params.data[4] * 100) / 100,
                            'Mediane: ' + Math.round(params.data[3] * 100) / 100,
                            '1er Quartile: ' + Math.round(params.data[2] * 100) / 100,
                            'Inférieur: ' + Math.round(params.data[1] * 100) / 100
                        ].join('<br/>')
                    } else {
                        // console.log('------------')
                        // console.log(params.dataIndex + ' - ' + params.data[1])
                        return 'Outlier : ' + Math.round(params.data[1] * 100) / 100
                    }
                }

                // formatter: 'min: {min} <br> Q1: {Q1}'
                // formatter: '1er Quartile : ' + formatNumber(this.premier_quartile_notes_finales) + '<br>Médiane : ' + formatNumber(this.mediane_notes_finales) + '<br>3eme Quartile : ' + formatNumber(this.troisieme_quartile_notes_finales)
            },
            xAxis: {
                type: 'value',
                name: '',
                min: 0,
                max: this.note_max
            },
            yAxis: {
                name: '',
                type: 'category'
            },
            series: [
                {
                    name: ' ',
                    type: 'boxplot',
                    datasetIndex: 1
                },
                {
                    name: 'Outlier',
                    type: 'scatter',
                    datasetIndex: 2,
                    itemStyle: {
                        color: '#5470C6'
                    },
                    label: {
                        show: true,
                        formatter: function(params: any) {
                            // on se sert du formatage d'un label vide pour faire l'incrémentation des entrées d'Outlier.
                            incrementArrayChartOutliersDetail('chart2', params.value)
                            return ''
                        }
                    },
                    tooltip: {
                        trigger: 'item',
                        axisPointer: {
                            type: 'shadow'
                        },
                        formatter: function(params: any) {
                            // reformatage du tooltip pour l'outlier
                            let nbrEntites = 0
                            if (params.value) {
                                nbrEntites = getCurrentNbOfCurrentOutliers('chart2', params.value)
                            }
                            return [
                                'Outlier : ' + params.value[1],
                                'Entités : ' + nbrEntites
                            ].join('<br/>')
                        }
                    }
                }
            ]
        }
    }

    resizeCharts () {
        if (this.$refs.chart1) {
            // Réinit forcé du tableau des nbr d'outliers
            this.$store.state.echartsToolsManage.arrayChartOutliersTotal = []
            this.$store.state.echartsToolsManage.arrayChartOutliersDetail = []

            const c2: any = this.$refs.chart2
            const c1: any = this.$refs.chart1
            c1.resize({
                width:'20px',
                height: '20px'
            })
            c2.resize({
                width:'20px',
                height:'20px'
            })
            setTimeout(() => {
                // Réinit forcé du tableau des nbr d'outliers
                this.$store.state.echartsToolsManage.arrayChartOutliersTotal = []
                this.$store.state.echartsToolsManage.arrayChartOutliersDetail = []

                const widthc1 = (this.$refs.chartBoite1 as HTMLElement).offsetWidth
                const heightc1 = (this.$refs.chartBoite1 as HTMLElement).offsetHeight
                c1.resize({
                    width: widthc1 + 'px',
                    height: heightc1 + 'px'
                })
                const widthc2 = (this.$refs.chartBoite2 as HTMLElement).offsetWidth
                const heightc2 = (this.$refs.chartBoite2 as HTMLElement).offsetHeight
                c2.resize({
                    width: widthc2 + 'px',
                    height: heightc2 + 'px'
                })
            }, 500)
        }
    }

    chargementNotes () {
        this.loadingData = true
        if (parseInt((this.selected_filiere_id).toString()) === 0) {
            this.epreuve_id = 0
            this.$store.dispatch('epreuveCorrectionResultat/getEpreuveCorrectionResultatsNotes', { epreuveCorrectionResultat_id: this.epreuvecorrectionId }).then(() => {
                this.loadingData = false
                this.buildChartOptions()
                setTimeout(() => {
                    // this.resizeCharts()
                    window.addEventListener('resize', () => {
                        this.resizeCharts()
                    })
                }, 500)
            }).catch((error) => {
                console.log('ko:' + error)
            })
        } else {
            this.selected_correcteur_id = 0
            for (let i = 0; i < this.$store.state.epreuveCorrectionResultat.epreuveCorrectionResultatSelect.epreuve_correction.epreuves.length; i++) {
                if (this.$store.state.epreuveCorrectionResultat.epreuveCorrectionResultatSelect.epreuve_correction.epreuves[i].concour_id === this.selected_filiere_id) {
                    this.epreuve_id = this.$store.state.epreuveCorrectionResultat.epreuveCorrectionResultatSelect.epreuve_correction.epreuves[i].id
                    this.$store.dispatch('epreuveCorrectionResultat/getEpreuveNotes', { epreuve_id: this.epreuve_id }).then(() => {
                        this.loadingData = false
                        this.buildChartOptions()
                        setTimeout(() => {
                            // this.resizeCharts()
                            window.addEventListener('resize', () => {
                                this.resizeCharts()
                            })
                        }, 500)
                    }).catch((error) => {
                        console.log('ko:' + error)
                    })
                }
            }
        }
    }

    chargementData () {
        this.$store.state.epreuveCorrectionResultat.notes = null
        this.$store.dispatch('epreuveCorrectionResultat/getEpreuveCorrectionCorrecteurs', { 'filter-epreuve_correction_id': this.epreuvecorrectionId }).then(() => {
            this.chargementNotes()
        }).catch((error) => {
            console.log('ko:' + error)
        })
    }

    mounted() {
        this.loadingData = true
        if (JSON.stringify(this.$store.state.epreuveCorrectionResultat.epreuveCorrectionResultatSelect) === '{}') {
            this.$store.dispatch('epreuveCorrectionResultat/getEpreuveCorrectionResultat', { epreuveCorrectionResultat_id: this.epreuvecorrectionId }).then(() => {
                this.chargementData()
            })
        } else {
            this.chargementData()
        }
    }

    beforeDestroy () {
        if (parseInt((this.selected_filiere_id).toString()) !== 0) {
            this.selected_filiere_id = 0
            this.chargementNotes()
        }
    }

    exportAsImage (elementDomId: string, rootFileExportName: string) {
        exportDivElementAsImage(elementDomId, rootFileExportName)
    }

    /** PLUS UTILISE POUR LE MOMENT ***********************************************************************
     * Exportation au format image/png de la liste de graphiques fournie en référence
     * Si plusieurs graphiques dans la liste, les images seront concaténées les unes en-dessous des autres
     */
    /*
    exportAsImage (listeOfCharts: any) {
        const listEcharts: any = []
        for (const chartIndex in listeOfCharts) {
            if (this.$refs[listeOfCharts[chartIndex]]) {
                listEcharts.push(this.$refs[listeOfCharts[chartIndex]])
            }
        }
        if (listEcharts.length > 0) {
            this.exportEchartsAsImage(listEcharts, 'Statistiques_Délibération')
        }
    }
    */
}
